import * as Yup from 'yup';

import { DESCRIPTION_CATEGORIES, KEYWORDS_CATEGORIES, PRODUCT_CATEGORIES } from '../../constants';
import { MenuCategoryEnum } from '../../constants/tool-categories';

export const getValidationSchema = (selectedCategory: number) => {
  const validationSchema = Yup.object().shape({
    product: PRODUCT_CATEGORIES.includes(selectedCategory)
      ? Yup.string().required('This field is Required')
      : Yup.string(),
    tellUsAboutYourself:
      MenuCategoryEnum.SOCIAL_MEDIA_BIO_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textToParaphrase:
      MenuCategoryEnum.REPHRASER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    wordToStart:
      MenuCategoryEnum.INSTAGRAM_HASHTAG_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    numberOfResults:
      MenuCategoryEnum.INSTAGRAM_HASHTAG_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    description: DESCRIPTION_CATEGORIES.includes(selectedCategory)
      ? Yup.string().required('This field is Required')
      : Yup.string(),
    purpose:
      MenuCategoryEnum.EMAIL_WRITER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    describeYourImage:
      MenuCategoryEnum.INSTAGRAM_CAPTION_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    keywords: KEYWORDS_CATEGORIES.includes(selectedCategory)
      ? Yup.string().required('This field is Required')
      : Yup.string(),
    textToBeSummarised:
      MenuCategoryEnum.SUMMARIZER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    ideaGeneratorTopic:
      MenuCategoryEnum.IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    blogIdeaGeneratorTopic:
      MenuCategoryEnum.BLOG_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    bookIdeaGeneratorTopic:
      MenuCategoryEnum.BOOK_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    businessIdeaGeneratorTopic:
      MenuCategoryEnum.BUSINESS_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    contentIdeaGeneratorTopic:
      MenuCategoryEnum.CONTENT_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    drawingIdeaGeneratorTopic:
      MenuCategoryEnum.DRAWING_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    giftIdeaGeneratorTopic:
      MenuCategoryEnum.GIFT_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    paintingIdeaGeneratorTopic:
      MenuCategoryEnum.PAINTING_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    sideHustleIdeaGeneratorTopic:
      MenuCategoryEnum.SIDE_HUSTLE_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    startupIdeaGeneratorTopic:
      MenuCategoryEnum.STARTUP_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    storyIdeaGeneratorTopic:
      MenuCategoryEnum.STORY_IDEA_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    articleWriterTopic:
      MenuCategoryEnum.ARTICLE_WRITER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    describeStory:
      MenuCategoryEnum.STORY_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    sloganWords:
      MenuCategoryEnum.MARKETING_SLOGAN_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textToGrammarCheck:
      MenuCategoryEnum.GRAMMAR_CHECKER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    titleGeneratorTopic:
      MenuCategoryEnum.TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    blogTitleGeneratorTopic:
      MenuCategoryEnum.BLOG_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    bookTitleGeneratorTopic:
      MenuCategoryEnum.BOOK_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    contentTitleGeneratorTopic:
      MenuCategoryEnum.CONTENT_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    documentTitleGeneratorTopic:
      MenuCategoryEnum.DOCUMENT_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    landingPageTitleGeneratorTopic:
      MenuCategoryEnum.LANDING_PAGE_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    socialMediaPostTitleGeneratorTopic:
      MenuCategoryEnum.SOCIAL_MEDIA_POST_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    storyTitleGeneratorTopic:
      MenuCategoryEnum.STORY_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    videoTitleGeneratorTopic:
      MenuCategoryEnum.VIDEO_TITLE_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    videoScriptGeneratorTopic:
      MenuCategoryEnum.VIDEO_SCRIPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    describeOutline:
      MenuCategoryEnum.PAGE_OUTLINE_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    describeTopic:
      MenuCategoryEnum.META_DATA_MAKER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    inputValue:
      MenuCategoryEnum.TRANSLATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    essayInput:
      MenuCategoryEnum.ESSAY_WRITER_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    createInput:
      MenuCategoryEnum.CREATE_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    createDetails:
      MenuCategoryEnum.CREATE_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    promptGeneratorTopic:
      MenuCategoryEnum.PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textPromptGeneratorTopic:
      MenuCategoryEnum.TEXT_PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    imagePromptGeneratorTopic:
      MenuCategoryEnum.IMAGE_PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    videoPromptGeneratorTopic:
      MenuCategoryEnum.VIDEO_PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    codePromptGeneratorTopic:
      MenuCategoryEnum.CODE_PROMPT_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    paragraphGeneratorTopic:
      MenuCategoryEnum.PARAGRAPH_GENERATOR_CATEGORY === selectedCategory ||
      MenuCategoryEnum.INTRODUCTION_PARAGRAPH_GENERATOR_CATEGORY === selectedCategory ||
      MenuCategoryEnum.BODY_PARAGRAPH_GENERATOR_CATEGORY === selectedCategory ||
      MenuCategoryEnum.CONCLUSION_PARAGRAPH_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    keywordsGeneratorTopic:
      MenuCategoryEnum.KEYWORD_GENERATOR_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textToExpand:
      MenuCategoryEnum.EXPAND_TEXT_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
    textToShorten:
      MenuCategoryEnum.SHORTEN_TEXT_CATEGORY === selectedCategory
        ? Yup.string().required('This field is Required')
        : Yup.string(),
  });
  return validationSchema;
};
